<template>
  <div>
<!--     <iframe class="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.688559421228!2d29.04923877221317!3d41.01018940389763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac62efff44639%3A0xfb9b1e2dc483f191!2sPixelate+Creative!5e0!3m2!1str!2str!4v1550736517153"
            width="100%" frameborder="0" style="border:0" allowfullscreen></iframe>

    <iframe class="map"
    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDYd2ezpHJldbKmnSC5WAkD4V&callback=initMap"
    width="100%" frameborder="0" style="border:0" allowfullscreen></iframe> -->

    <div class="gen-map">
      <div class="login-box__group user-settings__education">
        <p>AKILLI ARAMA</p>
        <div class="">
          <v-select placeholder="KONUM SEÇİNİZ" :options="city"/>
          <v-select placeholder="YURT ADI ARA" :options="dorm"/>
        </div>
      </div>

      <div class="user-settings__education bottom">
        <div class="check-gen">

          <label class="container2">
          <div class="check">
            <span class="name"> Kız Ög. Yurtları</span>

              <input type="checkbox">
              <span class="checkmark"></span>

            <img src="@/assets/img/icon-female.svg" alt="" class="icon">
          </div>
          </label>

          <label class="container2">
          <div class="check">
              <input type="checkbox">
              <span class="checkmark"></span>

            <span class="name"> Erkek Ög. Yurtları</span>
            <img src="@/assets/img/icon-male.svg" alt="" class="icon">
          </div>
          </label>

          <label class="container2">
          <div class="check">
              <input type="checkbox">
              <span class="checkmark"></span>
            <span class="name"> Üniversiteler</span>
            <img src="@/assets/img/icon-uni.svg" alt="" class="icon">
          </div>
          </label>

          <label class="container2">
          <div class="check">

              <input type="checkbox">
              <span class="checkmark"></span>

            <span class="name"> Diğer</span>
            <img src="@/assets/img/icon-uni.svg" alt="" class="icon">
          </div>
          </label>
        </div>

        <div class="check-gen">
          <label class="container2" style="width: 100%">
            <div class="check">
              <span class="name"> Yakınımdaki Yurtları Göster</span>
             <button></button>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectBox from '@/components/SelectBox'

export default {
  name: 'UserSettings',
  components: {
    SelectBox
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Akıllı Harita',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/akilli-harita/' }
      ] 
    }
  },   
  data () {
    return {
      show: false,
      city: [
        {
          label: 'İstanbul / Avrupa Yakası',
          value: 'istanbul-avrupa',
          selected: false
        },
        {
          label: 'İstanbul / Anadolu Yakası',
          value: 'istanbul-anadolu',
          selected: false
        },
        {
          label: 'İzmir',
          value: 'izmir',
          selected: false
        },
        {
          label: 'Ankara',
          value: 'ankara',
          selected: false
        },
        {
          label: 'Diyarbakır',
          value: 'diyarbakir',
          selected: false
        },
        {
          label: 'Eskişehir',
          value: 'eskisehir',
          selected: false
        },
        {
          label: 'Adana',
          value: 'adana',
          selected: false
        },
        {
          label: 'Çorum',
          value: 'corum',
          selected: false
        },
        {
          label: 'Konya',
          value: 'konya',
          selected: false
        }
      ],
      dorm: [
        {
          label: 'İstanbul / Avrupa Yakası',
          value: 'istanbul-avrupa',
          selected: false
        },
        {
          label: 'İstanbul / Anadolu Yakası',
          value: 'istanbul-anadolu',
          selected: false
        },
        {
          label: 'İzmir',
          value: 'izmir',
          selected: false
        },
        {
          label: 'Ankara',
          value: 'ankara',
          selected: false
        },
        {
          label: 'Diyarbakır',
          value: 'diyarbakir',
          selected: false
        },
        {
          label: 'Eskişehir',
          value: 'eskisehir',
          selected: false
        },
        {
          label: 'Adana',
          value: 'adana',
          selected: false
        },
        {
          label: 'Çorum',
          value: 'corum',
          selected: false
        },
        {
          label: 'Konya',
          value: 'konya',
          selected: false
        }
      ]
    }
  },
  methods: {
    initMap() {
  // The location of Uluru
  var uluru = {lat: -25.344, lng: 131.036};
  // The map, centered at Uluru
  var map = new google.maps.Map(
      document.getElementById('map'), {zoom: 4, center: uluru});
  // The marker, positioned at Uluru
  var marker = new google.maps.Marker({position: uluru, map: map});
}
  }
}

</script>

<style lang="scss">
  @import "../assets/scss/components/smart-map";
  @import "../assets/scss/components/user";

</style>
